import CourseCover from 'components/CourseCover'
import {FC} from 'external/react'

type CourseProps = {
    id: string,
    name: string
}

const Course: FC<CourseProps> = props => {
    const {id, name} = props
    return (
        <div className='containerSelected'>
            <div className='containerSelectedBody package-courses-detail'>
                <CourseCover id={id} name={name} />
            </div>
            <div className='containerSelectedFooter'>
                <p>{name}</p>
            </div>
        </div>
    )
}


export {Course as default}